import styles from "./WhyToxboxAIChatbot.module.css";
import {
    Brain,
    Clock,
    MessageSquare,
    Zap,
    Palette
} from "lucide-react";

const WhyToxboxAIChatbot = () => {
    return (
        <section className={styles.section}>
            {/* Heading */}
            <div className={styles.heading}>
                <h2>
                    Why ToxboxAI
                </h2>
                <p>
                    Most chatbots <span className={styles.muted}>talk.</span><br />
                    <span className={styles.highlight}>ToxboxAI closes.</span>
                </p>
            </div>

            {/* Cards */}
            <div className={styles.grid}>
                <div className={`${styles.card} ${styles.blue}`}>
                    <Brain />
                    <span>Trained on your website & data</span>
                </div>

                <div className={`${styles.card} ${styles.green}`}>
                    <Clock />
                    <span>Responds instantly, 24/7</span>
                </div>

                <div className={`${styles.card} ${styles.purple}`}>
                    <MessageSquare />
                    <span>Guides users step-by-step through forms</span>
                </div>

                <div className={`${styles.card} ${styles.orange}`}>
                    <Zap />
                    <span>Captures leads without friction</span>
                </div>

                <div className={`${styles.card} ${styles.pink}`}>
                    <Palette />
                    <span>Looks and sounds like your brand</span>
                </div>
            </div>

            {/* Bottom Note */}
            <div className={styles.note}>
                <p>This isn't customer support software.</p>
                <strong>It's a conversion assistant.</strong>
            </div>
        </section>
    );
};

export default WhyToxboxAIChatbot;